interface Category {
  id: string
  name: string
}

interface CategoryMultiSelectorProps {
  label: string
  selectedCategories: string[]
  onToggleCategory: (categoryId: string) => void
  onSelectAll: () => void
  onClearAll: () => void
  categories: Category[]
  className?: string
  showSelectAllControls?: boolean
  selectAllText?: string
  clearAllText?: string
}

export function CategoryMultiSelector({ 
  label, 
  selectedCategories, 
  onToggleCategory, 
  onSelectAll, 
  onClearAll,
  categories, 
  className = "",
  showSelectAllControls = true,
  selectAllText = "Select All",
  clearAllText = "Clear All"
}: CategoryMultiSelectorProps) {
  return (
    <div className={className}>
      <div className="flex justify-between items-center mb-3">
        <label className="block text-sm font-medium text-gray-700">
          {label} ({selectedCategories.length}/{categories.length})
        </label>
        {showSelectAllControls && (
          <div className="space-x-2">
            <button
              type="button"
              onClick={onSelectAll}
              className="text-xs text-blue-600 hover:text-blue-800"
            >
              {selectAllText}
            </button>
            <button
              type="button"
              onClick={onClearAll}
              className="text-xs text-gray-600 hover:text-gray-800"
            >
              {clearAllText}
            </button>
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 max-h-64 overflow-y-auto">
        {categories.map((category) => (
          <label key={category.id} className="flex items-center p-2 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
            <input
              type="checkbox"
              checked={selectedCategories.includes(category.id)}
              onChange={() => onToggleCategory(category.id)}
              className="mr-2"
            />
            <span className="text-sm font-medium truncate">{category.name || category.id}</span>
          </label>
        ))}
      </div>
    </div>
  )
}